import { IconButton, IconButtonProps } from '@components/icon-button';
import { IconDownload } from '@components/icons/download';
import { fetchAndDownload } from '@utils/download';
import { fileNameFromPath } from '@utils/strings';

export type DownloadButtonProps = {
  url?: string;
  filename?: string;
  variant?: IconButtonProps['variant'];
  base64File?: {
    filename: string;
    href: string;
  };
};

export const DownloadButton = ({
  url,
  filename,
  variant = 'secondary-purple',
  base64File,
}: DownloadButtonProps) => {
  if (!url && !base64File) return null;

  const handleDownload = () => {
    if (base64File) {
      const link = document.createElement('a');
      link.href = base64File.href;
      link.download = base64File.filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else if (url) {
      fetchAndDownload(url, filename ?? fileNameFromPath(url));
    }
  };

  return (
    <IconButton
      variant={variant}
      icon={<IconDownload />}
      onClick={handleDownload}
      dataTestid="download-button"
    />
  );
};
